import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy ,Pipe, PipeTransform} from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApploadServiceService } from 'projects/hp-api/src/lib/services/appload-service.service';
import { MatDialog } from '@angular/material/dialog';
import { FacebookService, InitParams, UIParams, UIResponse } from 'ngx-facebook';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SocialMediasComponent } from '../dialogs/social-medias/social-medias.component';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


interface DataSave {
  photo_name: string;
  pdf_name: string;
}
const httpoptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*' })
}
declare var gtag;
@Pipe({
  name: 'safe'
})

@Component({
  selector: 'app-finaliser',
  templateUrl: './finaliser-iframe.component.html',
  styleUrls: ['./finaliser-iframe.component.scss']
})
export class FinaliserIframeComponent extends WizardHpBaseComponent implements OnInit {
  devisForm: FormGroup;
  mat_stepper_width = 340;
  etape_show = false;
  name = 'ngx sharebuttons';
  lastData = [{
    "photo": "",
    "pdf": ""
  }];
  pdf_link = "";
  photo_link = "";
  href_iframe = "";
  screenProject: any;
  dataPdf: any;
  public hasSent = false;
  public beforeSending = false
  isSubmited = false;
  public cwData :any;
  emailForm: FormGroup;
  submitted = false;
  email_socialMedia = false;
  email_ok = false;
  popShare = false;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, public dialog: MatDialog,
    private fileUploadService: ApploadServiceService, router: Router,
    public fmail: FormBuilder,
    private http: HttpClient,
    private fb: FacebookService,

    private _bottomSheet: MatBottomSheet) {
      super(chgDetectorRef, hpService, router);

    this.getHpService().setHeaderIn(true);
    this.getHpService().setCurrentPage(this.getIndexNextUrl('simulateur-finalisation'))
    this.getHpService().setEtape_final(true);

    if (!this.getHpService().currentProduct) {
      this.getRouter().navigate([this.getHpService().getConfig().nav[0].link]);
    }

    this.lastData = [];
    this.screenProject = this.getHpService().getbase64String();
    this.href_iframe = this.getHpService().getHref_iframe();

  }

  ngOnInit() {
   this.sendMail();
   this.emailForm = this.fmail.group({
    email: ['', [Validators.required,Validators.email]]
    
       });
    setTimeout(() => {
      this.mat_stepper_width = this.mat_stepper_width + 165;
      this.etape_show = true;
    }, 1000);

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
   
  }
  openBottomSheet(): void {
   this. popShare = true;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  closeMesg(){
    this.popShare = false;
    this.submitted = false;
    this.email_socialMedia = false;
    this.email_ok = false;
   
  }
  toLink(url) {

    this.getRouter().navigate([url]);
  }

  sendMail() {
    // Simple POST request with a JSON body and response type <any>
    debugger;
    this.beforeSending = true;

    var currentData = this.getHpService().getCurrentSimulationData();
    
    //console.log(this.getHpService().getCurrentSimulationData())
    var formData =
    {
      "CLI_NOM": this.getHpService().getSlug(),
      "PRODUCTS_DATA" : currentData
    }
    /*
    for (var i = 0; i < currentData.length; i++) {
      formData[currentData[i].code] = currentData[i].label_answer;
    }
    */
    formData["IMG_LOGO"] = this.getHpService().getAssetsFullPath() + '/assets/images/logos/'
                            + 'logo.png';

    var dataMenuiserie = {
      "imageData": this.getHpService().getbase64String(),
      "modelGuid": this.getHpService().getPdfModelGuid(),
      "formData": formData,
      "mailTo": this.getHpService().getConfig().formulaires.email_dest
    }
    console.log(dataMenuiserie)
    var datam = encodeURIComponent(btoa(JSON.stringify(dataMenuiserie)));
    this.getHpService().sendMail(datam).subscribe({
      next: (data) => {

        this.cwData = data.root;
        this.hasSent = true;
        this.beforeSending = false;
        this.getHpService().postExternalMessage('CONFIGURATION_SAVED', this.cwData);
         
      },
      error: (error) => {
        console.log('error');
      }
    });
  }
  openLink(social: string, event:MouseEvent): void {

    switch(social)
    {
      case "facebook":
      {
        this.email_socialMedia =  false;
        //this.share();
       // this._bottomSheetRef.dismiss();
        event.preventDefault();
        break;
       
      }
      case "email":
        {
          this.email_socialMedia = (this.email_socialMedia) ? false:true;
         
          break;
        }
        case "whatsApp":
          {
            this.email_socialMedia =  false;
            window.open('whatsapp://send?text='+encodeURIComponent(""));
            break;
          }
          case "close":
            {
              this.email_socialMedia =  false;
             // this._bottomSheetRef.dismiss();
              event.preventDefault();
              break;
            }   
    }
  
  
  }
  onSubmit() {
    this.submitted = true;
      // stop here if form is invalid
    if (this.emailForm.invalid) {
        return;
    }
    this.email_ok = true;
   
     return;
     /**
      * En attente de confirmation du client, et création d'un modèle (Email) sans les cordonnées,
      * juste avec info produit.
      *  */ 
      
      this.beforeSending = true;
      var currentData = this.getHpService().getCurrentSimulationData();
      var re = /,/gi; 
      var formData =
      {
        "CLI_NOM": this.getHpService().getSlug(),
        "PRODUCTS_DATA" : currentData
      }
    
      /*
      for (var i = 0; i < currentData.length; i++) {
        formData[currentData[i].code] = currentData[i].label_answer;
      }
      */
  
      formData["IMG_LOGO"] = this.getHpService().getAssetsFullPath() + '/assets/images/logos/'
        +'logo.png';
  
      var dataMenuiserie = {
        "imageData": this.getHpService().getbase64String(),
        "modelGuid": this.getHpService().getPdfModelGuid(),
        "formData": formData,
        "mailTo": this.getHpService().getConfig().formulaires.email_dest
      }
    
      var datam = this.b64EncodeUnicode(JSON.stringify(dataMenuiserie));
      this.getHpService().sendMail(datam).subscribe({
        next: (data) => {
          this.cwData = data.root;
          this.hasSent = true;
          this.beforeSending = false;
          this.getHpService().postExternalMessage('CONFIGURATION_SAVED', this.cwData);
         
        },
        error: (error) => {
          console.log('error');
        }
      });
   
  
  }  
/*
get formControl for fields
*/
get f() { return this.emailForm.controls; }
/**
   * 
   * @param str 
   * Encoding UTF-8 --> base64
   * @returns 
   */
b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
  }))
}

share() {
 
  const params: UIParams = {
   
    method: 'feed',
    display: 'popup',
    name:"Simulateur de portes swao",
    href: 'https://simulateur.simuleo.com/swao',
    caption: 'Simulateur de portes swao',
    picture: 'https://simulateur.simuleo.com/simulation/photos/'+'.jpg',
    description: "Simulateur de portes swao"
    
  };
 
  this.fb.ui(params)
    .then((res: UIResponse) => console.log(res))
    .catch((e: any) => console.error(e));
 
}

}
